import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem, g as global$1, h as hasNamedSlot } from './index.esm-7182addc.js';
import { t as toggleBodyScrolling } from './toggleBodyScrolling-727a628b.js';

const gravityModalCss = ".gravity-modal{background-color:#FFFFFF;border-radius:8px;box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;display:flex;flex-direction:column;gap:40px;max-height:100%;max-width:100%;opacity:0;padding:32px;position:relative;text-align:center;transform:scale(0.98);transform-origin:50% 50%;transition:all 150ms cubic-bezier(0.32, 0, 0.32, 1)}.gravity-modal--show{opacity:1;transform:none}.gravity-modal__content-container{display:flex;flex-direction:column;gap:4px;overflow:hidden}.gravity-modal__header-body-container{display:flex;flex-direction:column;gap:12px;overflow:hidden}.gravity-modal--size-medium{width:320px}.gravity-modal--size-large{width:400px}.gravity-modal__overlay{align-items:center;background-color:rgba(0, 15, 30, 0.6);box-sizing:border-box;display:flex;height:100%;justify-content:center;left:0;opacity:0;overflow:hidden;padding:48px;pointer-events:none;position:fixed;top:0;transition:opacity 150ms linear;width:100%;z-index:3000}.gravity-modal__overlay--visible{backdrop-filter:blur(10px);opacity:1;pointer-events:auto}.gravity-modal__closeable-container{align-items:flex-end;display:flex;height:22px}.gravity-modal__close-button{all:unset;border-radius:50%;cursor:pointer;margin-inline-start:auto;position:relative;transform:translate(6px, -6px)}.gravity-modal__close-button:focus-visible{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-modal--closeable ::slotted([slot=header]){align-items:center;display:flex;flex-direction:column;gap:2px}.gravity-modal ::slotted([slot=footer]){align-items:flex-start;display:flex;flex-wrap:wrap;gap:8px;justify-content:center}.gravity-modal__body{overflow-y:auto}";
const GravityModalStyle0 = gravityModalCss;

const GravityModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.isOpen = createEvent(this, "isOpen", 5);
        this.generateClassnames = bem('gravity-modal');
        /**
         * Handles the ESC key press event. When the ESC key is pressed and the modal is visible, it closes the modal.
         * @param {KeyboardEvent} event - The keyboard event.
         * @private
         */
        this.handleEscKeyPress = (event) => {
            if (event.key === 'Escape' && this.isVisible && this.closeable) {
                this.closeModal();
            }
        };
        /**
         * Handles a click event on the close button. If the modal is visible, it closes the modal.
         * @private
         */
        this.handleCloseButtonClick = () => {
            if (this.isVisible) {
                this.closeModal();
            }
        };
        this.setBackdropElement = (el) => {
            if (!el) {
                return;
            }
            this.backdropElement = el;
        };
        this.closeable = true;
        this.for = '';
        this.open = false;
        this.size = 'medium';
        this.isVisible = false;
    }
    updateOpenStatus(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (this.open && !this.isVisible) {
                this.openModal();
            }
            else if (!this.open && this.isVisible) {
                this.closeModal();
            }
        }
    }
    /**
     * Opens the modal and emits the `isOpen` event.
     * @private
     */
    openModal() {
        this.isVisible = true;
        this.open = true;
        toggleBodyScrolling('off');
        this.isOpen.emit(this.open);
    }
    /**
     * Closes the modal, then emits the `isOpen` event after a brief delay for the CSS transition.
     * @private
     */
    closeModal() {
        this.open = false;
        this.isVisible = false;
        toggleBodyScrolling('on');
        setTimeout(() => {
            this.isOpen.emit(this.open);
        }, 150);
    }
    /**
     * Handles a click event on the backdrop (dimmed background). If the modal is closable and visible, it closes the modal.
     * @private
     */
    handleBackdropMouseDown(event) {
        const { target } = event;
        if (target == this.backdropElement && this.closeable && this.isVisible) {
            this.closeModal();
        }
    }
    /**
     * Sets up the trigger element that opens the modal when clicked.
     * Fetches the trigger element based on the 'for' property value.
     * If 'for' is provided, it attempts to find an element with matching ID within the parent node.
     * If 'for' is not provided or no element is found, it defaults to the parent element of the modal.
     * If a valid 'for' prop is provided, it also binds a click event listener to the trigger element that opens the modal.
     * @private
     */
    setupTriggerElement() {
        var _a;
        // Determine the trigger element.
        this.triggerElement = this.for
            ? ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.for}`)) || global$1.document.querySelector(`#${this.for}`)
            : this.element.parentElement;
        // Bind the click event listener if a valid trigger element is set.
        if (this.for && this.triggerElement) {
            this.triggerElement.onclick = (event) => {
                event.stopPropagation();
                if (!this.isVisible) {
                    this.openModal();
                }
            };
        }
    }
    connectedCallback() {
        this.escKeyListener = this.handleEscKeyPress.bind(this);
        global$1.window.addEventListener('keydown', this.escKeyListener);
    }
    componentWillLoad() {
        this.setupTriggerElement();
        if (this.open) {
            this.openModal();
        }
    }
    disconnectedCallback() {
        toggleBodyScrolling('on');
        global$1.window.removeEventListener('keydown', this.escKeyListener);
        this.element.remove();
    }
    render() {
        return (h("div", { key: '35ba0267898758a7deb0d571ead394b073a1a321', ref: this.setBackdropElement, class: this.generateClassnames('overlay', {
                visible: this.isVisible,
            }), onMouseDown: (event) => this.handleBackdropMouseDown(event) }, h("div", { key: '9f5ba98dfb6d6c764813337e4a4e30368de1086f', class: this.generateClassnames({
                show: this.isVisible,
                size: this.size,
                closeable: this.closeable,
            }) }, h("div", { key: '044cabf4013b6a2b4991be7b77eeb18b370c99ba', class: this.generateClassnames('content-container') }, this.closeable && (h("div", { key: '6a9fb0b05b05ec1b58a598765ce7cafd5525a37e', class: this.generateClassnames('closeable-container') }, h("button", { key: '126d9ee377908d87576d6adc52f2836bc933f639', class: this.generateClassnames('close-button'), onClick: this.handleCloseButtonClick }, h("gravity-icon", { key: '1e570a8da7c1570685f34847fe06d37bcb0f9a3e', name: "close", size: "small" })))), h("div", { key: 'b03cad7b7b319249fde075d614413f61e55d9179', class: this.generateClassnames('header-body-container') }, hasNamedSlot(this.element, 'header') && (h("div", { key: '892c691630b9db837b33343469d171fcd75840d0', class: this.generateClassnames('header') }, h("slot", { key: '49b9ba19a93a0c63bffcfdb920386d1ab9849c75', name: "header" }))), hasNamedSlot(this.element, 'body') && (h("div", { key: '1d0b6ade74fd7e5277db90320194ed0e07769637', class: this.generateClassnames('body') }, h("slot", { key: 'f5840f75d8632f9a4db04e33ca7c4614dee4f0da', name: "body" }))))), hasNamedSlot(this.element, 'footer') && (h("div", { key: '493ffedea2164292aeb0958c3f71d1a59395585c', class: this.generateClassnames('footer') }, h("slot", { key: '1974836e8d5bd4d6bc701172945f0b6c7d7b81d3', name: "footer" }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "open": ["updateOpenStatus"]
    }; }
};
GravityModal.style = GravityModalStyle0;

export { GravityModal as gravity_modal };

//# sourceMappingURL=gravity-modal.entry.js.map